import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const OfferIntro = loadable(() => import('./OfferIntro'), {
  fallback: <LoadingScreen />,
});

const OfferIntroError = loadable(() => import('./Error'), {
  fallback: <LoadingScreen />,
});

export default OfferIntro;
export { OfferIntroError };
